/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Discussion_ChannelsInputs */

const en_discussion_channels = /** @type {(inputs: Discussion_ChannelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discussion Channels`)
};

const es_discussion_channels = /** @type {(inputs: Discussion_ChannelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canales de Discusión`)
};

const fr_discussion_channels = /** @type {(inputs: Discussion_ChannelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canaux de discussion`)
};

const de_discussion_channels = /** @type {(inputs: Discussion_ChannelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diskussionskanäle`)
};

const id_discussion_channels = /** @type {(inputs: Discussion_ChannelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saluran Diskusi`)
};

/** @type {(inputs: Discussion_ChannelsInputs) => LocalizedString} */
const ja_discussion_channels = en_discussion_channels;

/** @type {(inputs: Discussion_ChannelsInputs) => LocalizedString} */
const zh_discussion_channels = en_discussion_channels;

/** @type {(inputs: Discussion_ChannelsInputs) => LocalizedString} */
const ar_discussion_channels = en_discussion_channels;

/** @type {(inputs: Discussion_ChannelsInputs) => LocalizedString} */
const it_discussion_channels = en_discussion_channels;

/** @type {(inputs: Discussion_ChannelsInputs) => LocalizedString} */
const ru_discussion_channels = en_discussion_channels;

/** @type {(inputs: Discussion_ChannelsInputs) => LocalizedString} */
const pt_discussion_channels = en_discussion_channels;

/** @type {(inputs: Discussion_ChannelsInputs) => LocalizedString} */
const ko_discussion_channels = en_discussion_channels;

/**
* | output |
* | --- |
* | "Discussion Channels" |
*
* @param {Discussion_ChannelsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const discussion_channels = /** @type {((inputs?: Discussion_ChannelsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Discussion_ChannelsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_discussion_channels(inputs)
	if (locale === "es") return es_discussion_channels(inputs)
	if (locale === "fr") return fr_discussion_channels(inputs)
	if (locale === "de") return de_discussion_channels(inputs)
	if (locale === "ja") return ja_discussion_channels(inputs)
	if (locale === "zh") return zh_discussion_channels(inputs)
	if (locale === "ar") return ar_discussion_channels(inputs)
	if (locale === "id") return id_discussion_channels(inputs)
	if (locale === "it") return it_discussion_channels(inputs)
	if (locale === "ru") return ru_discussion_channels(inputs)
	if (locale === "pt") return pt_discussion_channels(inputs)
	return ko_discussion_channels(inputs)
});